export default __webpack_public_path__ + "static/media/Asp of Mystical Supremacy.edc4623a.jpg";